
import { larryBio } from './leonBios'
import { larryReviewerReviewHinge, larryReviewerReviewBumble, larryReviewerReviewTinder } from './leonReviewerReviews'

export const larryReviewerProfile = {
  _id: 'larryReviewerProfileId',
  userId: 'larryUserId',
  email: 'larry@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-larry-2-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...larryBio },
  profileReviews: [
    // { ...larryProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...larryReviewerReviewHinge },
    { ...larryReviewerReviewBumble },
    { ...larryReviewerReviewTinder }
  ],
}